import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { OmitStylesHTMLAttributes } from '../../types';

const breadcrumbItemVariants = cva('rocco-breadcrumb-item', {
    variants: {
        variant: {
            default: 'inline-flex items-center gap-1.5',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const BreadcrumbItem = React.forwardRef<
    HTMLLIElement,
    OmitStylesHTMLAttributes<HTMLLIElement> &
        VariantProps<typeof breadcrumbItemVariants>
>(({ variant, ...props }, ref) => (
    <li ref={ref} className={breadcrumbItemVariants({ variant })} {...props} />
));

BreadcrumbItem.displayName = 'BreadcrumbItem';
